<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Sample: <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run='+samId" target="_blank">{{this.samId}}  &nbsp; <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></h3>
                </b-col>
            </b-row>            
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <ul>
                        <li><b>Sample ID:</b> <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run='+samId" target="_blank">{{this.samId}}  &nbsp; <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></li>
                        <li><b>ProjectID:</b>
                            <router-link :to="{ path: '/viewsample/'+samInfo.ProjectID}" target="_blank" v-b-tooltip.hover title="View Project details in our database">&nbsp;{{this.samInfo.ProjectID}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>&nbsp;
                            <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + samInfo.ProjectID" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                        </li>
                        <li><b>Sample details:</b>{{this.samInfo.Original_Sample_Description}}</li>
                        <li><b>Total Number of eMGEs found:</b> <span style="color:red;font-weight: bold;">{{this.samples_data.length}}</span></li>
                        <li><b>Instrument model:</b>{{this.samInfo.InstrumentModel ? this.samInfo.InstrumentModel : 'NA'}}</li>
                        <li><b>Disease:</b>{{this.samInfo.Disease ? this.samInfo.Disease : 'NA'}}</li>
                        <li><b>Phenotype:</b>{{this.samInfo.Phenotype ? this.samInfo.Phenotype : 'NA'}}</li>
                        <li><b>Sample Classification:</b>{{this.samInfo.GOLDSampleClassification ? this.samInfo.GOLDSampleClassification : 'NA'}}</li>
                        <li><b>Country:</b>{{this.samInfo.Country ? this.samInfo.Country : 'NA'}}</li>
                        <li><b>Host Age:</b>{{this.samInfo.HostAge ? this.samInfo.HostAge : 'NA' }}</li>
                    </ul>
                </b-col>
            </b-row>
            <b-row v-if="showPlot">
                <b-col>
                    <Plotly :data="barPlotDat" :layout="retLayout" :autoResize="true"></Plotly>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <h3>Associated eMGEs</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p><download-csv
                            :data   = "samples_data" style="cursor: pointer;">
                        To download the eMGE data for this sample <span style="color:red;font-weight: bold;"> {{samId}} </span> in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                </b-col>
            </b-row>
            <b-row style="margin-top:10px;margin-bottom:10px">                            
                        <b-col>
                        <b-input-group style="margin-top:10px;margin-bottom:10px">
                                        <!-- <label for="filterHmPairs" style="padding-top:5px">Search</label> -->
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        id="filterHmPairs"
                                        placeholder="Type to Search"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>                
                        </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="samIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="samples_data"
                        :fields="sample_fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(MGEs_id) ="row">
                                <router-link :to="{ path: '/viewmge/'+row.item.MGEs_id.trim()}" target="_blank">{{row.item.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                        </template>
                        <template v-slot:cell(Genome_quality) ="row">
                                <span v-if="row.item.Genome_quality != null && row.item.Genome_quality != 'NULL'">
                                    {{row.item.Genome_quality}}
                                </span>
                                <span v-else>
                                    NA
                                </span>
                        </template>
                        <template v-slot:cell(MGEs_cluster) ="row">
                                <span v-if="row.item.MGEs_cluster != 'singlet'">
                                    <router-link :to="{ path: '/viewcluster/'+row.item.MGEs_cluster.trim()}" target="_blank">{{row.item.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                </span>
                                <span v-else>
                                    {{row.item.MGEs_cluster.trim()}}
                                </span>
                        </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalSamRows"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:false,
            filter:null,
            samIsBusy:true,
            samples_data:[],
            sample_fields:[
                { key:'MGEs_id',label:'eMGE ID',sortable:false },
                { key: 'status', label: 'Type', sortable: false },
                { key: 'MGEs_cluster', label: 'eMGE cluster', sortable: true},
                { key: 'contig_length', label: 'Length', sortable: true},
                { key: 'structure', label: 'Structure', sortable: true},
                { key: 'Genome_quality', label: 'Quality', sortable: true},
                { key: 'abundance', label: 'Relative abundance', sortable: true},
            ],
            totalSamRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            samId:'',
            samInfo:'',
            barPlotDat:[],
            retLayout:{
                title:'eMGE Type distribution',
            },
            showPlot:false,
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.samId = this.$route.params.samid
            this.importSamDet()
            this.importSampleList()
            // this.importGraphData()
        },
        importSamDet(){
            axios.post(this.server_add+'query/getSam',
            {
                samId:this.samId
            },{ timeout: 300000}).then(retDat => {
                if(retDat.status == 200){
                    this.samInfo = retDat.data
                    this.showPage = true
                }
            }).catch(err => {
                console.log(err)
            })
        },
        importSampleList(){
            axios.post(this.server_add+'query/listMGEsBig',
            {
                samId:this.samId
            },{ timeout: 30000000}).then(retDat => {
                // console.log(retDat)
                if(retDat.status == 200 && retDat.data.length >=1 && retDat.data != 'error:no mge found'){ //retDat.data.length >=1
                    this.samples_data = retDat.data
                    this.samIsBusy = false
                    this.totalSamRows = this.samples_data.length
                    this.loadTypeGraph()
                    this.showPage = true
                }else if(retDat.data == 'error:no mge found'){
                    this.samIsBusy = false
                    this.showPage = true
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadTypeGraph(){
            var grp =  _.groupBy(this.samples_data,'status')
            var keyMap = Object.keys(grp)
            var szMap = Object.values(grp).map(p=>p.length)
            var total = szMap.reduce((a, b) => a + b)
            var text = szMap.map((v, i) => `${keyMap[i]}<br>${'Total eMGEs:'+v}<br>${parseFloat(v / total * 100).toFixed(1)}%`)
            this.barPlotDat = [{
                type: "pie",
                values: szMap,
                labels: keyMap,
                textinfo: "label+percent",
                textposition: "outside",
                automargin: true,
                text:text,
                hoverinfo: 'text'
            }]
            this.showPlot = true
        }
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}
</style>